// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ue-btn-select-xsm{background:#f0f8ff;border:none;min-width:80px;padding:0}.ue-btn-select-lg{background:#f9f9f9}", "",{"version":3,"sources":["webpack://./resources/js/admin/components/dashboard/FormDetailAvisDecision.scss"],"names":[],"mappings":"AAAA,mBACI,kBAAA,CACA,WAAA,CAEA,cAAA,CADA,SACA,CAGJ,kBACI,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
